import { InjectionToken } from '@angular/core';

export const MAP_POPUP_DATA = new InjectionToken<any>('MAP_POPUP_DATA');
